import { createStore } from 'redux';

import PayablesTableState, { getInitialState } from './PayablesTable.state';

enum StoreActionType {
  SetPendingPayablesState,
  SetCompletedPayablesState,
  AddPayableSuccess,
  Reset,
}

interface SetPendingPayablesStateAction {
  readonly type: StoreActionType.SetPendingPayablesState;
  readonly payload: PayablesTableState;
}

interface SetCompletedPayablesStateAction {
  readonly type: StoreActionType.SetCompletedPayablesState;
  readonly payload: PayablesTableState;
}

interface AddPayableSuccessAction {
  readonly type: StoreActionType.AddPayableSuccess;
}

interface ResetAction {
  readonly type: StoreActionType.Reset;
}

type StoreAction =
  | SetPendingPayablesStateAction
  | SetCompletedPayablesStateAction
  | AddPayableSuccessAction
  | ResetAction;

interface State {
  pendingPayablesState: PayablesTableState;
  completedPayablesState: PayablesTableState;
}

const initialState: State = {
  pendingPayablesState: getInitialState(true, ''),
  completedPayablesState: getInitialState(false, ''),
};

const reducer = (state: State, action: StoreAction): State => {
  switch (action.type) {
    case StoreActionType.SetPendingPayablesState:
      return {
        ...state,
        pendingPayablesState: action.payload,
      };
    case StoreActionType.SetCompletedPayablesState:
      return {
        ...state,
        completedPayablesState: action.payload,
      };
    case StoreActionType.AddPayableSuccess:
      return {
        ...state,
        pendingPayablesState: {
          ...state.pendingPayablesState,
          grandTotalNumberOfRecords: state.pendingPayablesState.grandTotalNumberOfRecords + 1,
        },
      };
    case StoreActionType.Reset:
      return { ...initialState };
    default:
      return state;
  }
};

/**
 * Redux store. Allows to store React state outside of component
 * to preserve component state between navigations to other pages
 */
const store = createStore(reducer, initialState);

const selectPendingPayablesState = (state: State) => state.pendingPayablesState;
const selectCompletedPayablesState = (state: State) => state.completedPayablesState;

export { StoreActionType, selectPendingPayablesState, selectCompletedPayablesState };
export default store;
